import 'remodal';

// ─── News 設定値 ───
const NEWS_JSON_PATH = '/static/docs/c/pages/andst_creators/assets/data/news.json';
// news.html（全件ページ）1ページあたりの表示件数
const NEWS_PAGE_SIZE = 12;
// index.html（トップのプレビュー枠）に表示する件数。null なら全件表示
// 12件で固定。超過分は MORE ボタン → news.html（全件ページ）へ誘導
const NEWS_HOME_LIMIT = 12;
// category → 表示ラベルの例外（category.toUpperCase() と食い違うものだけ書く）
// 例: collab → COLLABO（フィルターボタンの data-filter="collab" 表記は変えない）
const CATEGORY_LABEL_OVERRIDES = { collab: 'COLLABO' };

// ─── 公開制御（news.json の publish フィールド）───
//   "publish": true              → 表示（フィールドを書かなくても同じ＝既存件は無記入でよい）
//   "publish": false             → 非表示
//   "publish": "2026-07-16 12:00" → その時刻を過ぎたら表示（それまで非表示）
// 判定は閲覧者の端末の時計で行う（サーバー時刻ではないので数分のズレは出る）
function isPublished(item) {
	const publish = item.publish;
	if (publish === undefined || publish === null || publish === true) return true;
	if (publish === false) return false;
	// new Date('2026-07-16 12:00') はブラウザによって NaN になるため、自前で分解して組み立てる
	const m = String(publish).match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
	// 書式ミスは非表示に倒す。表示に倒すと、タイポに気付かないまま解禁前に出てしまうため
	if (!m) {
		console.warn('publish の書式が不正なので非表示にしました:', item.id, publish);
		return false;
	}
	return Date.now() >= new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]).getTime();
}

// ─── Drawer Menu ───
const burger = document.getElementById('navBurger');
const navLinks = document.getElementById('navLinks');
const body = document.body;

if (burger && navLinks) {
	let scrollPosition = 0;

	const openNav = () => {
		scrollPosition = window.scrollY || document.documentElement.scrollTop;
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		burger.classList.add('nav__burger--open');
		navLinks.classList.add('nav__links--open');
		body.classList.add('nav-open');
		body.style.cssText = `position:fixed;width:100%;height:100%;top:-${scrollPosition}px;padding-right:${scrollbarWidth}px`;
	};

	const closeNav = () => {
		burger.classList.remove('nav__burger--open');
		navLinks.classList.remove('nav__links--open');
		body.classList.remove('nav-open');
		body.removeAttribute('style');
		window.scrollTo(0, scrollPosition);
	};

	burger.addEventListener('click', (e) => {
		e.preventDefault();
		body.classList.contains('nav-open') ? closeNav() : openNav();
	});

	navLinks.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', closeNav);
	});

	window.addEventListener('orientationchange', () => {
		body.removeAttribute('style');
		body.classList.remove('nav-open');
		burger.classList.remove('nav__burger--open');
		navLinks.classList.remove('nav__links--open');
	});
}

// ─── Anim on scroll (.anim + .active) ───
const animObserver = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');

				// グリッド内のカードを順次フェードイン
				const cards = entry.target.querySelectorAll('.creators__card, .news__card');
				if (cards.length) {
					const readyClass = (card) => card.classList.contains('creators__card') ? 'creators__card--ready' : 'news__card--ready';
					const showClass = (card) => card.classList.contains('creators__card') ? 'creators__card--show' : 'news__card--show';

					cards.forEach((card) => card.classList.add(readyClass(card)));

					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							let delay = 0;
							cards.forEach((card) => {
								setTimeout(() => {
									card.classList.remove(readyClass(card));
									card.classList.add(showClass(card));
								}, delay);
								delay += 80;
							});
						});
					});
				}
			}
		});
	},
	{ rootMargin: '0px 0px -10% 0px' }
);
document.querySelectorAll('.anim').forEach((el) => animObserver.observe(el));


// ─── News Cards: JSONから動的生成 ───
function escapeHtml(s) {
	if (!s) return '';
	return String(s)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

// カテゴリ表示ラベルは category を大文字化するだけだと合わないものだけ上の CATEGORY_LABEL_OVERRIDES に例外を書く
// （例: collab → COLLABO。フィルターボタンの data-filter="collab" 表記に合わせて category 自体は変更しない）
function categoryLabel(category) {
	return CATEGORY_LABEL_OVERRIDES[category] || category.toUpperCase();
}

// 本文中の裸のURL（http(s)://…）を <a target="_blank"> に変換（エスケープ後の文字列に対して適用）
// URLを1回書くだけ＝「表示テキストと飛び先が食い違う」事故が構造的に起きない
// 文字クラスをURL使用可の文字だけに絞ってあるので、直後に「。」等の日本語が続いても巻き込まない
// （\n → <br /> を先に処理済みなので、行末URLが <br /> を飲み込むこともない）
function renderBodyParagraph(paragraph) {
	return escapeHtml(paragraph)
		.replace(/\n/g, '<br />')
		.replace(/(https?:\/\/[\w\-.~:/?#[\]@!$&'()*+,;=%]+)/g, '<a href="$1" target="_blank">$1</a>');
}

// 段落1つ分を描画。「書きたいものをそのまま書く」方式で記法は無い
//   "/…/xxx.jpg" → 画像ブロック（画像パスが単独で置かれていたらそれだけで画像になる）
//   "文章"       → テキスト段落（\n=改行 / 裸URL=自動リンク）
// 画像を <p> で包むとテキスト用の行間が乗るため分ける。figure は使わない（案件ルール）
const BODY_IMAGE_PATH = /^\/\S+\.(?:jpe?g|png|webp|gif|svg)$/i;
function newsBodyBlockHtml(block) {
	const s = String(block).trim();
	if (BODY_IMAGE_PATH.test(s)) {
		// 本文画像は寸法が記事ごとに違うため width/height は付けない（モーダルが開くまで読まれないので lazy のみ）
		return `<div class="news__modal-image"><img src="${escapeHtml(s)}" alt="" loading="lazy" /></div>`;
	}
	return `<p>${renderBodyParagraph(block)}</p>`;
}

// news.json の body は1つの文字列。改行だけで構造を表す（JSONの "," や "" を書かなくてよい）
//   \n\n … 段落の区切り（<p> が分かれる）
//   \n   … 段落内の改行（<br />）
function newsBodyHtml(body) {
	return String(body)
		.split(/\n{2,}/)
		.map(newsBodyBlockHtml)
		.join('\n            ');
}

function cardHtml(item) {
	return `<div class="news__card" data-category="${escapeHtml(item.category)}" data-modal="${escapeHtml(item.id)}">
          <div class="news__category news__category--${escapeHtml(item.category)}">${escapeHtml(categoryLabel(item.category))}</div>
          <img class="news__thumb" src="${escapeHtml(item.thumb)}" alt="" loading="lazy" width="750" height="750" />
          <div class="news__title">${escapeHtml(item.title)}</div>
          <div class="news__meta"><span>${escapeHtml(item.date)}</span><span class="news__meta-arrow">→</span></div>
        </div>`;
}

function modalHtml(item) {
	return `<div class="remodal" data-remodal-id="${escapeHtml(item.id)}" data-remodal-options="hashTracking: false">
          <button data-remodal-action="close" class="remodal-close"></button>
          <img class="news__modal-thumb" src="${escapeHtml(item.thumb)}" alt="" loading="lazy" width="750" height="750" />
          <div class="news__category news__category--${escapeHtml(item.category)}">${escapeHtml(categoryLabel(item.category))}</div>
          <h3 class="news__modal-title">${escapeHtml(item.title)}</h3>
          <div class="news__modal-date">${escapeHtml(item.date)}</div>
          <div class="news__modal-body">
            ${newsBodyHtml(item.body)}
            <p class="news__modal-close"><button data-remodal-action="close">| × CLOSE |</button></p>
          </div>
        </div>`;
}

// news.html 用: フィルター(category)とページ(page)を両方URLに載せる
// 例: ?category=pr&page=2（all・1ページ目は省略してURLを短く保つ）
// リンク先は location.pathname＝「今開いているページ自身」。'news.html' と直書きしない
//   本番のNEWSページは /cp/andst_creators_news で配信されるため、相対の 'news.html' だと
//   /cp/andst_creators_news/news.html を指して404になる。pathname ならローカル・本番の両方で正しく動く
function buildNewsUrl(category, page) {
	const params = new URLSearchParams();
	if (category && category !== 'all') params.set('category', category);
	if (page && page > 1) params.set('page', page);
	const qs = params.toString();
	return location.pathname + (qs ? '?' + qs : '');
}

function getUrlCategory() {
	return new URLSearchParams(location.search).get('category') || 'all';
}

function getUrlPage() {
	const p = parseInt(new URLSearchParams(location.search).get('page'), 10);
	return Number.isInteger(p) && p > 0 ? p : 1;
}

function renderPager(container, category, page, totalPages) {
	if (!container) return;
	if (totalPages <= 1) {
		container.innerHTML = '';
		return;
	}
	const link = (p) => buildNewsUrl(category, p);
	const prev = page > 1
		? `<a class="news__pager-btn" href="${link(page - 1)}">← PREV</a>`
		: `<span class="news__pager-btn news__pager-btn--disabled">← PREV</span>`;
	const next = page < totalPages
		? `<a class="news__pager-btn" href="${link(page + 1)}">NEXT →</a>`
		: `<span class="news__pager-btn news__pager-btn--disabled">NEXT →</span>`;
	const numbers = Array.from({ length: totalPages }, (_, i) => i + 1).map((p) =>
		p === page
			? `<span class="news__pager-btn news__pager-btn--active">${p}</span>`
			: `<a class="news__pager-btn" href="${link(p)}">${p}</a>`
	).join('');
	container.innerHTML = prev + numbers + next;
}

const newsGrid = document.querySelector('.news__grid');
const newsModals = document.querySelector('.news__modals');
const newsPagerEl = document.querySelector('.news__pager');
const isNewsPaginated = newsGrid?.dataset.paginate === 'true';
let remodalCache = {};
let allNewsItems = [];

// カテゴリ・ページに応じて一覧とモーダルを描画し直す（news.htmlのフィルター／ページャーの実体）
// 重要: カテゴリ絞り込みは「今表示中のカード」ではなく allNewsItems（全件）に対して行う
//       （表示中の1ページ分だけで絞り込むと、他ページにしかないカテゴリが消えて見える不具合になるため）
function renderNews(category, page) {
	const filtered = category === 'all' ? allNewsItems : allNewsItems.filter((item) => item.category === category);
	let pageItems = filtered;

	if (isNewsPaginated) {
		const totalPages = Math.max(1, Math.ceil(filtered.length / NEWS_PAGE_SIZE));
		if (page > totalPages) page = totalPages;
		if (page < 1) page = 1;
		pageItems = filtered.slice((page - 1) * NEWS_PAGE_SIZE, page * NEWS_PAGE_SIZE);
		renderPager(newsPagerEl, category, page, totalPages);
	} else if (NEWS_HOME_LIMIT != null) {
		pageItems = filtered.slice(0, NEWS_HOME_LIMIT);
	}

	newsGrid.innerHTML = pageItems.map(cardHtml).join('');

	if (newsModals) {
		// 既存のremodalインスタンスを破棄してから作り直す
		// （Remodalはinit時にモーダルを .remodal-wrapper ごとDOM外へ移動するため、
		//   destroy()せずにnewsModals.innerHTMLを差し替えると移動済みの旧要素が残留する）
		Object.values(remodalCache).forEach((instance) => instance.destroy());
		remodalCache = {};
		newsModals.innerHTML = pageItems.map(modalHtml).join('');
		document.querySelectorAll('[data-remodal-id]').forEach((modal) => {
			const id = modal.getAttribute('data-remodal-id');
			if (id) remodalCache[id] = $(modal).remodal({ hashTracking: false });
		});
	}

	document.querySelectorAll('.news__filter-btn').forEach((btn) => {
		btn.classList.toggle('news__filter-btn--active', btn.dataset.filter === category);
	});
}

// URLハッシュをスクロール発生なしで除去するユーティリティ
function stripHashNoScroll() {
	const cleanUrl = window.location.href.split('#')[0];
	if (window.location.href !== cleanUrl) {
		history.replaceState(null, '', cleanUrl);
	}
}

// 下層(news.html)のグロナビから index.html#stage 等で来た時の着地位置を補正する
// ブラウザはHTMLを読んだ直後にアンカーへ飛ぶが、その時点では news/creators のグリッドが
// 空（高さ0）。あとからJSONで各11枚が描画されると、それより下にある
// #creators / #stage / #contact が一気に押し下げられて着地位置がズレる。
// → 描画が終わってから、もう一度ハッシュの位置を取り直す（初回描画時のみ呼ぶ）
// モーダル用ハッシュ（#news001 等）はモーダルを開く側の担当なので対象外にする
function rescrollToSectionHash() {
	const hash = window.location.hash;
	if (!hash || /^#news\d+$/.test(hash)) return;
	const el = document.getElementById(hash.slice(1)); // 不正な文字列でも例外を出さない
	if (!el) return;
	// CSSの scroll-behavior:smooth を打ち消して即座に合わせる（読み込み時のズレ補正のため）
	el.scrollIntoView({ behavior: 'instant', block: 'start' });
}

if (newsGrid) {
	fetch(NEWS_JSON_PATH)
		.then((res) => res.json())
		.then((items) => {
			// 公開時刻前・非表示指定のものはここで落とす（以降の絞り込み・ページ送りの件数計算も自動で正しくなる）
			allNewsItems = items.filter(isPublished);
			renderNews(getUrlCategory(), getUrlPage());
			rescrollToSectionHash(); // 描画で高さが変わるので着地位置を取り直す（初回のみ）

			// カードクリックで開く（ハッシュ手動付与でシェアURL機能維持）
			// news__grid は再描画のたびに中身が入れ替わるため、委譲で拾う
			newsGrid.addEventListener('click', function (e) {
				const card = e.target.closest('.news__card');
				if (!card) return;
				const modalId = card.dataset.modal;
				if (!modalId || !remodalCache[modalId]) return;
				history.replaceState(null, '', '#' + modalId);
				remodalCache[modalId].open();
			});

			// 閉じたとき：ハッシュを確実に除去（trailing `#` も残らないように）
			$(document).on('closed', '.remodal', stripHashNoScroll);

			// 初回ロード時にURLハッシュがあれば対応モーダルを開く
			const hash = window.location.hash;
			const modalId = hash.replace(/^#/, '');
			if (/^news\d+$/.test(modalId) && remodalCache[modalId]) {
				setTimeout(() => remodalCache[modalId].open(), 0);
			}

			if (isNewsPaginated) {
				// ブラウザの戻る／進むでカテゴリ・ページのURLが変わった時も再描画する
				window.addEventListener('popstate', () => {
					renderNews(getUrlCategory(), getUrlPage());
				});
			}
		})
		.catch((err) => console.warn('news load failed:', err));
}

// ─── Creators Cards: JSONから動的生成 ───
const CREATORS_JSON_PATH = '/static/docs/c/pages/andst_creators/assets/data/creators.json';

// バッジ色は category から自動判定（JSONに色を書かない）。新カテゴリ追加時のみここに1行足す
const CATEGORY_BADGE_COLOR = { creator: 'yellow', instore: 'purple', partner: 'mint' };
function categoryBadgeColor(category) {
	return CATEGORY_BADGE_COLOR[category] || 'yellow';
}

// SNS種別 → アイコンHTML / title のマッピング（新しいSNSはここに1行足すだけ）
const CREATOR_SNS = {
	staffboard: { title: 'STAFF BOARD', icon: '<img src="/static/docs/c/pages/andst_creators/assets/img/ico_sb.svg" alt="STAFF BOARD" class="creators__sns-icon" />' },
	instagram: { title: 'Instagram', icon: '<i class="fa-brands fa-instagram"></i>' },
	tiktok: { title: 'TikTok', icon: '<i class="fa-brands fa-tiktok"></i>' },
	youtube: { title: 'YouTube', icon: '<i class="fa-brands fa-youtube"></i>' },
	spotify: { title: 'Spotify', icon: '<i class="fa-brands fa-spotify"></i>' },
	x: { title: 'X', icon: '<i class="fa-brands fa-x-twitter"></i>' },
	wear: { title: 'WEAR', icon: '<img src="/static/docs/c/pages/andst_creators/assets/img/ico_wear.svg" alt="WEAR" class="creators__sns-icon" />' },
};

function creatorSnsHtml(sns) {
	return (sns || [])
		.map((s) => {
			const conf = CREATOR_SNS[s.type];
			if (!conf) return '';
			return `<a href="${escapeHtml(s.url)}" target="_blank" class="creators__sns-link" title="${conf.title}">${conf.icon}</a>`;
		})
		.join('\n              ');
}

// フォロワー枠は任意（くるみん・りょうくんのように0件のクリエイターもいる）
function creatorFollowersHtml(followers) {
	if (!followers || !followers.length) return '';
	const items = followers
		.map(
			(f) => `<div class="creators__follower">
                <div class="creators__follower-num">${escapeHtml(f.num)}</div>
                <div class="creators__follower-label">${escapeHtml(f.label)}</div>
              </div>`
		)
		.join('\n              ');
	return `<div class="creators__card-followers">
              ${items}
            </div>`;
}

function creatorCardHtml(item) {
	const tags = (item.tags || []).map((t) => `<span class="creators__tag">${escapeHtml(t)}</span>`).join('');
	return `<div class="creators__card" data-category="${escapeHtml(item.category)}">
          <div class="creators__card-media">
            <img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.name)}" loading="lazy" width="750" height="750" />
          </div>
          <div class="creators__card-info">
            <div class="creators__card-name">${escapeHtml(item.name)}</div>
            <div class="creators__card-badge creators__card-badge--${categoryBadgeColor(item.category)}">${escapeHtml(categoryLabel(item.category))}</div>
            <div class="creators__card-desc">${escapeHtml(item.desc)}</div>
            <div class="creators__card-tags">${tags}</div>
            <div class="creators__card-sns">
              ${creatorSnsHtml(item.sns)}
            </div>
            ${creatorFollowersHtml(item.followers)}
          </div>
        </div>`;
}

const creatorsGrid = document.querySelector('.creators__grid');
if (creatorsGrid) {
	fetch(CREATORS_JSON_PATH)
		.then((res) => res.json())
		.then((items) => {
			// JSONの並び順がそのまま掲載順（news.json と同じ思想）
			creatorsGrid.innerHTML = items.map(creatorCardHtml).join('');
			rescrollToSectionHash(); // 描画で高さが変わるので着地位置を取り直す（初回のみ）
		})
		.catch((err) => console.warn('creators load failed:', err));
}

// ─── Filter helper ───
function filterCards(cards, filter, showClass) {
	const readyClass = showClass.replace('--show', '--ready');

	// 1. transition無効でリセット → 該当カードをopacity:0で配置
	cards.forEach((card) => {
		card.style.transition = 'none';
		card.classList.remove(showClass, readyClass);
		if (filter === 'all' || card.dataset.category === filter) {
			card.style.display = '';
			card.classList.add(readyClass);
		} else {
			card.style.display = 'none';
		}
	});

	// 2. 描画を挟んでtransition復帰 → 順次フェードイン
	requestAnimationFrame(() => {
		cards.forEach((card) => { card.style.transition = ''; });
		requestAnimationFrame(() => {
			let delay = 0;
			cards.forEach((card) => {
				if (filter === 'all' || card.dataset.category === filter) {
					setTimeout(() => {
						card.classList.remove(readyClass);
						card.classList.add(showClass);
					}, delay);
					delay += 80;
				}
			});
		});
	});
}

// ─── Creators Filter ───
document.querySelectorAll('.creators__filter-btn').forEach((btn) => {
	btn.addEventListener('click', function () {
		document.querySelectorAll('.creators__filter-btn').forEach((b) =>
			b.classList.remove('creators__filter-btn--active')
		);
		this.classList.add('creators__filter-btn--active');
		filterCards(document.querySelectorAll('.creators__card'), this.dataset.filter, 'creators__card--show');
	});
});

// ─── News Filter ───
// news.html（ページャーあり）: allNewsItems全件からカテゴリ絞り込み→再描画し、URLも書き換える
// index.html（プレビュー枠・ページャーなし）: 従来通り表示中のカードをその場でフェード切り替え
document.querySelectorAll('.news__filter-btn').forEach((btn) => {
	btn.addEventListener('click', function () {
		const category = this.dataset.filter;

		if (isNewsPaginated) {
			renderNews(category, 1);
			history.pushState(null, '', buildNewsUrl(category, 1));
			return;
		}

		document.querySelectorAll('.news__filter-btn').forEach((b) =>
			b.classList.remove('news__filter-btn--active')
		);
		this.classList.add('news__filter-btn--active');
		filterCards(document.querySelectorAll('.news__grid .news__card'), category, 'news__card--show');
	});
});
